import { getStore } from '@/utils/dva'

const config: any = {
    dev: 'erp_token_dev',
    prod: 'erp_token' // pre ,prod
}
// 判断字符是否以pre开头
const key = REACT_APP_ENV.indexOf('prod') > -1 || REACT_APP_ENV.indexOf('pre') > -1 ? 'prod' : 'dev'
export const erpTokenKey = config[key]

// 获取供应链下商家的的cid
export function getCid(): number | string {
    const { currentUser } = getStore?.()?.getState?.()?.user || {}

    return (currentUser && Number(currentUser.coId)) || ''
}

// 获取供应链下商家的的_uid
export function get_Uid(): number | string {
    const { currentUser } = getStore?.()?.getState?.()?.user || {}

    return (currentUser && Number(currentUser.uid)) || ''
}

export function transformDataParams2<T>(data: T): {
    coid: number
    uid: number
    data: T
} {
    return {
        coid: getCid(),
        uid: get_Uid(),
        data: data
    }
}

// 获取erp token
export function getErpToken() {
    const { erpToken } = getStore().getState().user || {}
    return erpToken || ''
}

// 获取erp token
export async function asycGetErpToken() {
    return await getStore().dispatch({
        type: 'user/getErpToken'
    })
}

export const zoneMaxGoodsNums = 10000
export const formatTotal = (total: number) => {
    return total === zoneMaxGoodsNums ? '10000+' : total
}
